import React from 'react'
import { DeleteBillRateFlowProvider } from './context/DeleteBillRateFlowProvider'
import { DeleteBillRateFlowMain } from './components/DeleteBillRateFlowMain'
import { useBillRatesWorkflowsContextValue } from '../../context/BillRatesWorkflowsProvider'

export const DeleteBillRateFlow = () => {
  const { deleteBillRateFlow } = useBillRatesWorkflowsContextValue()

  if (!deleteBillRateFlow.billRate) {
    return null
  }

  return (
    <DeleteBillRateFlowProvider>
      <DeleteBillRateFlowMain billRate={deleteBillRateFlow.billRate} />
    </DeleteBillRateFlowProvider>
  )
}
